import { Card, CardContent } from "@/components/ui/card";

export function NotComputedCard() {
  return <Card><CardContent><p className="text-sm text-muted-foreground">This view has not been computed yet.</p></CardContent></Card>;
}
